var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.828,
    height: 25,
    viewBox: "0 0 20.828 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2217",
    "data-name": "Raggruppa 2217",
    transform: "translate(-13215.054 21676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3530",
    "data-name": "Tracciato 3530",
    d: "M5,16.142a9.783,9.783,0,0,1,.369-3.774A9.022,9.022,0,0,1,7.818,9.613L9.163,8.385c2.506-2.289,3.759-3.433,5.251-3.433S17.159,6.1,19.665,8.385L21.01,9.613a9.021,9.021,0,0,1,2.449,2.755,9.782,9.782,0,0,1,.369,3.774v6.077c0,2.7,0,4.053-.788,4.893s-2.056.84-4.592.84H10.379c-2.536,0-3.8,0-4.592-.84S5,24.921,5,22.219Z",
    transform: "translate(13211.054 -21679.951)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3531",
    "data-name": "Tracciato 3531",
    d: "M16.224,23.069V16.345A1.345,1.345,0,0,0,14.879,15H10.845A1.345,1.345,0,0,0,9.5,16.345v6.724",
    transform: "translate(13212.605 -21675.068)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home-white.7370ee7be6d3d9782dce09f89d2b6b0c.svg";
export { ForwardRef as ReactComponent };